import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import UsersPage from './pages/UsersPage';
import SessionsPage from './pages/SessionsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AdminSupportResources from './pages/AdminSupportResources';
import TimetablesPage from './pages/TimetablesPage';
import GradesClassesPage from './pages/GradesClassesPage';
import EducatorAssignmentsPage from './pages/EducatorAssignmentsPage';
import AdminAssessmentsPage from './pages/AdminAssessmentsPage';
import AdminRecordingsPage from './pages/AdminRecordingsPage';
import AdminSubjectsPage from './pages/AdminSubjectsPage';
import ProtectedRoute from './components/ProtectedRoute';

// Educator (legacy tutor) experience
import EducatorDashboard from './pages/EducatorDashboard';
import EducatorClasses from './educator-dashboard/MyTimetable';
import EducatorStudents from './educator-dashboard/Students';
import EducatorMessages from './educator-dashboard/Messages';
import EducatorSettings from './educator-dashboard/Settings';
import EducatorSupport from './educator-dashboard/Support';
import EducatorAnnouncements from './educator-dashboard/Announcements';
import EducatorRecordings from './educator-dashboard/Recordings';
import EducatorLessons from './educator-dashboard/Lessons';
import EducatorAssessments from './educator-dashboard/Assessments';
import EducatorResources from './educator-dashboard/Resources';
import EducatorAnalytics from './educator-dashboard/Analytics';

// Student experience
import StudentDashboard from './pages/StudentDashboard';
import StudentClasses from './student-dashboard/MyTimetable';
import StudentProgress from './student-dashboard/Progress';
import StudentSubjects from './student-dashboard/Subjects';
import StudentEducators from './student-dashboard/Educators';
import StudentAssessments from './student-dashboard/Assessments';
import StudentSettings from './student-dashboard/Settings';
import StudentSupport from './student-dashboard/Support';
import StudentAnnouncements from './student-dashboard/Announcements';
import StudentRecordings from './student-dashboard/Recordings';
import StudentResources from './student-dashboard/Resources';

import ParentDashboard from './parent-dashboard/Dashboard';
import ParentTimetable from './parent-dashboard/Timetable';
import ParentLessonsAssessments from './parent-dashboard/LessonsAssessments';
import ParentBilling from './parent-dashboard/Billing';
import ParentNotifications from './parent-dashboard/Notifications';

import MeetingEnded from './shared/MeetingEnded';

const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route
      path="/admin"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AdminDashboard />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/users"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <UsersPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/sessions"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <SessionsPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/analytics"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AnalyticsPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/support"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AdminSupportResources />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/timetables"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <TimetablesPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/grades"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <GradesClassesPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/assignments"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <EducatorAssignmentsPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/assessments"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AdminAssessmentsPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/subjects"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AdminSubjectsPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/admin/recordings"
      element={(
        <ProtectedRoute roles={['superadmin', 'admin']}>
          <AdminRecordingsPage />
        </ProtectedRoute>
      )}
    />

    {/* Educator routes */}
    <Route
      path="/educator"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorDashboard />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/classes"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorClasses />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/students"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorStudents />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/messages"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorMessages />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/settings"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorSettings />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/support"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorSupport />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/announcements"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorAnnouncements />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/recordings"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorRecordings />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/homework"
      element={<Navigate to="/educator" replace />}
    />
    <Route
      path="/educator/resources"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorResources />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/lessons"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorLessons />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/assessments"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorAssessments />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/educator/analytics"
      element={(
        <ProtectedRoute roles={['educator']}>
          <EducatorAnalytics />
        </ProtectedRoute>
      )}
    />

    {/* Student routes */}
    <Route
      path="/student"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentDashboard />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/dashboard"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentDashboard />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/classes"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentClasses />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/progress"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentProgress />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/subjects"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentSubjects />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/assessments"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentAssessments />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/educators"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentEducators />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/tutors"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentEducators />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/messages"
      element={<Navigate to="/student/dashboard" replace />}
    />
    <Route
      path="/student/settings"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentSettings />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/homework"
      element={<Navigate to="/student/assessments" replace />}
    />
    <Route
      path="/student/support"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentSupport />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/announcements"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentAnnouncements />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/recordings"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentRecordings />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/student/resources"
      element={(
        <ProtectedRoute roles={['student']}>
          <StudentResources />
        </ProtectedRoute>
      )}
    />

    {/* Parent routes */}
    <Route
      path="/parent"
      element={(
        <ProtectedRoute roles={['parent']}>
          <ParentDashboard />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/parent/timetable"
      element={(
        <ProtectedRoute roles={['parent']}>
          <ParentTimetable />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/parent/lessons"
      element={(
        <ProtectedRoute roles={['parent']}>
          <ParentLessonsAssessments />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/parent/billing"
      element={(
        <ProtectedRoute roles={['parent']}>
          <ParentBilling />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/parent/notifications"
      element={(
        <ProtectedRoute roles={['parent']}>
          <ParentNotifications />
        </ProtectedRoute>
      )}
    />

    <Route path="/meeting-ended" element={<MeetingEnded />} />

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default App;
